import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import config from 'temp/config';
import { ComponentType } from 'react';

const defaultBrowserHistory = {
  url: '/',
  location: { pathname: '' },
  state: { url: '' },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  listen: () => {},
};

let browserHistory = defaultBrowserHistory;

if (typeof window !== 'undefined') {
  browserHistory = { ...browserHistory, ...window.history };
  browserHistory.location.pathname = browserHistory?.state?.url;
}

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: config?.nextPublicAppinsightsConnectionString,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

if (!!config?.nextPublicAppinsightsConnectionString) {
  appInsights.loadAppInsights();
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (Component: ComponentType<unknown>) => withAITracking(reactPlugin, Component);
export { reactPlugin, appInsights };
